import _ from 'lodash'

const state = {
  ranges: [
    {
      space: 10,
      price: 0
    }, {
      space: 100,
      price: 5.99
    }, {
      space: 500,
      price: 19.99
    }, {
      space: 1024,
      price: 29.99
    }, {
      space: 2024,
      price: 59.99
    }, {
      space: 5 * 1024,
      price: 109.99
    }, {
      space: 10 * 1024,
      price: 209.99
    }
  ]
}
const getters = {
  ranges (state) {
    return state.ranges
  },
  rangesCopy (state) {
    return _.cloneDeep(state.ranges)
  },
  goodRangeForSpace (state) {
    return (space) => {
      for (let range of state.ranges) {
        if (range.space * 1024 * 1024 > space) {
          return range
        }
      }
      return {
        space: 10 * 1024,
        price: 209.99
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters
}




// WEBPACK FOOTER //
// ./src/store/files.js